import { message } from 'ant-design-vue'
import ConverWorker from './conver.worker?worker'
import { MD5 } from 'crypto-js'
import { onBeforeUnmount, onMounted, reactive, watchEffect } from 'vue'
import { QWebChannel } from './qwebchannel.js'
import type { IConfig, MianWorkerRc } from './helper.js'
import { API_FILE_UPLOAD } from '@/api/file/index.js'
export default () => {
  const worker = new ConverWorker()
  // const { upload } = useUpload()
  const config = reactive<IConfig>({
    instance: null,
    loading: true,
    error: false,
    scanSize: 'setScanSize_A4',
    priResolution: '1280 * 1024',
    priResolutionList: [],
    priImageData: '',
    priPhotoData: [],
    saveToLocal: false,
    delBgColor: false,
    isDeskew: false
  })
  // 主线程接收工作线程的消息
  worker.onmessage = (event: MessageEvent<MianWorkerRc>) => {
    const { file, uid } = event.data
    for (let i = 0; i < config.priPhotoData.length; ++i) {
      const item = config.priPhotoData[i]
      if (item.uid === uid) {
        Object.assign(item, {
          file,
          status: 'convered'
        })
        break
      }
    }
  }
  const reloadSignal = () => {
    config.loading = true
    config.instance.get_actionType('closeSignal')
    setTimeout(() => {
      config.instance.html_loaded('one')
    })
  }
  const initSignal = () => {
    config.loading = true
    config.error = false
    config.instance = null
    const socket = new WebSocket('ws://127.0.0.1:12345')
    socket.onclose = function (e: CloseEvent) {
      config.loading = false
      if (e.code !== 1000) {
        config.error = true
      }
      console.info('高拍仪closed', e)
    }
    socket.onerror = function (error) {
      config.loading = false
      config.error = true
      console.error('高拍仪error', error)
    }
    socket.onopen = function () {
      new QWebChannel(socket, function (channel) {
        config.instance = channel.objects.dialog
        // 网页关闭函数
        window.onbeforeunload = function () {
          config.instance.get_actionType('closeSignal')
        }
        window.onunload = function () {
          config.instance.get_actionType('closeSignal')
        }
        // 设置图片尺寸
        config.instance.get_actionType(config.scanSize)

        // 服务器返回消息
        config.instance.sendPrintInfo.connect(function (message) {
          if (message.indexOf('savePhoto_success:') >= 0) {
            console.log('图片保存成功')
          }
          // 获取到图片质量列表。（可能存在取不到的情况）
          if (message.indexOf('priResolution:') >= 0) {
            message = message.substr(14)
            config.priResolutionList.push({
              label: message,
              value: message
            })
            if (config.priResolutionList.length > 3) {
              config.priResolution = config.priResolutionList[0].value
              config.loading = false
            }
          }
        })
        // 接收图片用来展示，多个，较小的base64，主头数据
        config.instance.send_priImgData.connect(function (message) {
          window.requestAnimationFrame(() => {
            config.priImageData = 'data:image/jpg;base64,' + message
          })
        })
        // 接收拍照base64，主头数据
        config.instance.send_priPhotoData.connect(function (message) {
          const base64 = `data:image/jpg;base64,${message}`
          const uid = MD5(base64).toString().toUpperCase()
          config.priPhotoData.unshift({
            uid,
            base64,
            status: 'convering'
          })
          worker.postMessage({ uid, base64 })
        })

        // 网页加载完成信号
        config.instance.html_loaded('one')
        config.instance.set_configValue('set_savePath:C:/rszb')
      })
    }
  }

  /**
   * @description 设置图片尺寸
   */
  const setScanSize = size => {
    config.instance?.get_actionType(size)
  }
  /**
   * @description 设置图片质量
   */
  const setPriResolution = size => {
    config.instance?.devChanged('primaryDev_:' + size)
  }
  /**
   * @description 左转
   */
  const rotateLeft = () => {
    config.instance?.get_actionType('rotateLeft')
  }
  /**
   * @description 右转
   */
  const rotateRight = () => {
    config.instance?.get_actionType('rotateRight')
  }
  /**
   * @description 拍摄
   */
  const handleCapture = () => {
    if (config.loading) return message.info('请稍后')
    config.instance?.photoBtnClicked('primaryDev_')
    config.saveToLocal && config.instance?.get_actionType('savePhotoPriDev')
  }
  /**
   * @description 底色处理
   */
  const delBgColor = () => {
    config.instance?.get_actionType(config.delBgColor ? 'delbkcolorOff' : 'delbkcolor')
    config.delBgColor = !config.delBgColor
  }
  /**
   * @description 纠偏裁边处理
   */
  const setDeskew = () => {
    config.instance?.get_actionType(config.isDeskew ? 'setdeskewOff' : 'setdeskew')
    config.isDeskew = !config.isDeskew
  }
  /**
   * @description 批量上传
   */
  const handleUpload = async () => {
    config.loading = true
    const _needUpload = config.priPhotoData.filter(item => item.status === 'convered' && item.file)
    const num: [number, number] = [0, 0]
    const data = await Promise.allSettled(
      _needUpload.map(item => {
        Object.assign(item, { status: 'uploading' })
        // return upload({
        //   name: item.file?.name as string,
        //   uid: item.uid,
        //   file: item.file as File
        // })
        return API_FILE_UPLOAD({
          file: item.file as File
        })
      })
    )
    for (let i = 0; i < data.length; ++i) {
      if (data[i].status === 'fulfilled') {
        num[0]++
        Object.assign(_needUpload[i], { status: 'uploaded' })
      } else {
        num[1]++
        Object.assign(_needUpload[i], { status: 'convered' })
      }
    }
    config.loading = false
    message.info(`本次上传：${num[0]}成功，${num[1]}失败`)
  }
  watchEffect(() => {
    setScanSize(config.scanSize)
  })
  watchEffect(() => {
    setPriResolution(config.priResolution)
  })
  // watchEffect(() => {
  //   setLs('__GPY_SAVA_TO_LOCAL__', config.saveToLocal)
  // })
  onMounted(() => {
    initSignal()
  })
  onBeforeUnmount(() => {
    config.instance?.get_actionType('closeSignal')
  })
  return {
    reloadSignal,
    initSignal,
    rotateLeft,
    rotateRight,
    delBgColor,
    setDeskew,
    handleCapture,
    handleUpload,
    config
  }
}
